export interface IBillingShippingModel{
    ODataEtag:String,
    Number:String,
    publicId:String,
    CustomerNo:String,
    publicSalesPersoncode:String,
    BillToName:String,
    BillToAddress1:String,
    BillToAddress2:String,
    BillToCity:String,
    BillToState:String,
    BillToZipcode:String,
    BillToCountryCode:String,
    ShipToCode:String,
    ShipToName:String,
    ShipToAddress1:String,
    ShipToAddress2:String,
    ShipToCity:String,
    ShipToState:String,
    ShipToZipcode:String,
    ShipToCountryCode:String,
    CustomerTelephone:String,
    CustomerEmailAddress:String,
    CustomerFaxno:String,
    ShippingTelephoneno:String,
    ShippingFaxno:String,
    ShippingEmailAddress:String,
    Rep1:String,
    Rep2:String,
    Sales1:String,
    Sales2:String
}
export enum SCALType{
    'SCAL-D 360'= 1,
    'SCAL-N 360'= 2,
}
export enum SCALOperations{
    'add'=1,
    'edit'=2,
    'addMore'=3
}
export enum  SCALRenewalType{
    'Renew Based on Expiration Date'=1,
    'Renew Based on Current Purchase Date'=2
}
export enum SCALOsDetailType{
    'Windows 11'=1,
    'Windows 10'=2,
    'Windows 8.1'=3,
    'Windows 8'=4,
    'Windows 7'=5,
    'Windows Server 2019'=6,
    'Windows Server 2016'=7,
    'Windows Server 2012 R2'=8,
    'Windows Server 2012'=9,
    'Windows Server 2008 R2'=10,
    'Windows Server 2008'=11,
}
export enum LicensePortalProduct{
    LZ30=19,
    SmartLink360=20,
    Service360=22,
    SCAL=14,
    SmartCal360N=11,
    SYNCIt=1000,
    GIS360=23
}
export enum ProductClientSecret{
    LZ30="f0631e1a5c310c3093b01768ccc495ba",
    SmartLink360="bc5897005257f20324acff937ca1426f",
    Service360="ca17d891365396e696362635c79fb348",
    SCAL="54012654468d382b6f75159d7fd6fe75",
    SmartCal360N="b204de74a5fa459cd1bdbd45f1a2c791",
    SyncIT="CXFXxsCT1m5PkgRNOj8RRDlO0szixBrm",
    GIS360="31Gp916ie8W7pYjCQi4fNYHXBnVuVbte"
}

export enum PortalAccess{
    OTA=1,
    LicensingAndAdv=2,
    All=3
}
export enum OTARoles{
    Developer=1,
    QA=2,
    'Product Management'=3
}
export enum LicenseRoles{
    CSR=1
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/interfaces/LicenseModel.ts